import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';
import { i18nState } from 'redux-i18n';

import { httpInProgressReducer } from '../app/shared/http-in-progress/reducers/http-in-progress-reducer';
import { loginReducer } from '../app/main/login/reducers/login-reducer';
import { registerReducer } from '../app/main/register/reducers/register-reducer';
import { forgotPasswordReducer } from '../app/main/forgot-password/reducers/forgot-password-reducer';
import { resetPasswordReducer } from '../app/main/reset-password/reducers/reset-password-reducer';
import { infoModalReducer } from '../app/shared/info-modal/reducers/info-modal-reducers';
import { userProfileReducer } from '../app/main/user-profile/reducers/user-profile-reducer';
import { paymentsReducer } from '../app/main/payments/reducers/payment-reducer';
import { layoutReducer } from '../app/main/layout/reducers/layout-reducer';
import { dashboardReducer } from '../app/main/dashboard/reducers/dashboard-reducer';
import { bannersReducer } from '../app/main/banners/reducers/banners-reducer';
import { campaignsReducer } from '../app/main/campaigns/reducers/campaigns-reducer';
import { clientsReducer } from '../app/main/clients/reducers/clients-reducer';
import { linkCreatorReducer } from '../app/main/link-creator/reducers/link-creator-reducer';
import { commissionReducer } from '../app/main/commission-plans/reducers/commission-reducer';
import { sourcesReducer } from '../app/main/sources/reducers/sources-reducer';
import { reportsReducer } from '../app/main/reports/reducers/reports-reducer';
import { paymentMethodsReducer } from '../app/main/payment-methods/reducers/payment-methods-reducer';
import { b2bReducer } from '../app/main/b2b/reducers/b2b-reducer';
import { withdrawalReducer } from '../app/main/withdrawals/reducers/withdrawal-reducer';
import { commissionSchemeReducer } from '../app/main/commission-scheme/reducers/commission-scheme-reducer';

const rootReducer = combineReducers({
  i18nState,
  httpInProgressReducer,
  loginReducer,
  registerReducer,
  forgotPasswordReducer,
  resetPasswordReducer,
  infoModalReducer,
  userProfileReducer,
  paymentsReducer,
  layoutReducer,
  dashboardReducer,
  bannersReducer,
  campaignsReducer,
  clientsReducer,
  linkCreatorReducer,
  commissionReducer,
  sourcesReducer,
  reportsReducer,
  paymentMethodsReducer,
  b2bReducer,
  withdrawalReducer,
  commissionSchemeReducer,
  form: formReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/core/root-reducer.js